export const agentPlayground = {
  header: {
    title: "Teste do Agente de IA",
    chip: "Recepção IA · Beta",
    sub: "Converse com o agente avançado sem enviar nada pelo WhatsApp.",
  },
  context: {
    title: "Contexto",
    listingLabel: "Anúncio",
    listingPlaceholder: "Selecione um anúncio…",
    allListings: "🌐 Todas as acomodações (novas reservas)",
    accountModeHint:
      "O agente responde como se não estivesse vinculado a uma acomodação específica: ideal para testar solicitações de reserva.",
    guestStatusLabel: "Status do hóspede",
    stay: {
      auto: "Automático",
      inStay: "Hospedado atualmente (durante a estadia)",
      beforeArrival: "Ainda não chegou (reserva futura)",
      after: "Estadia finalizada",
    },
    guestStatusHint: "Simule o momento do hóspede para ver as diferentes respostas.",
    reservationIdLabel: "ID da reserva",
    optional: "(opcional)",
    reservationIdPlaceholder: "ex.: 1234",
    phoneLabel: "Telefone do hóspede",
    phonePlaceholder: "+34...",
    langLabel: "Idioma",
    lang: {
      auto: "Automático",
      es: "Espanhol",
      en: "Inglês",
      pt: "Português",
      fr: "Francês",
      de: "Alemão",
      pl: "Polonês",
    },
    reset: "Reiniciar conversa",
  },
  debug: {
    resolvedTitle: "Contexto resolvido",
    listing: "Anúncio",
    property: "Propriedade",
    reservation: "Reserva",
    checkin: "Check-in",
    checkout: "Check-out",
    lang: "Idioma",
    toolsTitle: "Ferramentas usadas",
  },
  chat: {
    emptyPrompt: "Escreva uma mensagem como se você fosse o hóspede.",
    pay: "Pagar",
    book: "Reservar",
    sentAsButton: "No WhatsApp é enviado como um botão",
    sentAsList: "No WhatsApp é enviado como uma lista · {button}",
    inputPlaceholder: "Escreva uma mensagem…",
  },
  suggestions: {
    s1: "Que horas é o check-in?",
    s2: "Tem estacionamento?",
    s3: "Tem wifi? Qual é a senha?",
    s4: "Posso fazer o check-in mais cedo?",
  },
  errors: {
    loadListings: "Não foi possível carregar os anúncios.",
    chatError: "Erro ao falar com o agente.",
    chatReplyFallback: "⚠️ Não consegui responder. Verifique o contexto ou tente novamente.",
  },
  methods: {
    listingFallback: "Anúncio #{id}",
  },
};
